module.exports = __webpack_public_path__ + "img/bdMap.a11a59d6.png";